module.exports = __webpack_public_path__ + "img/bell-no-white.90979ea2.svg";